import { Strings } from "@/resources";
import { sanitizeHtml } from "@/Helpers/DraftEditor";
import './terms.scss';

export default function TermsModal({
    show,
    description,
    use_pdf,
    file_url,
    setTermsAccepted,
    submit,
    openLinkInNewTab,
    isUpdate,
} : {
    show?: boolean;
    description?: string;
    use_pdf?: boolean;
    file_url?: string;
    setTermsAccepted: (val: boolean) => void;
    submit: (e?: any) => void;
    openLinkInNewTab?: (url: string) => void;
    isUpdate?: boolean;
}) {

    const language = Strings.accept_terms;


    return (
        <div
            className={`flashcard-container ${show ? "show" : ""}`}
        >
            <div className="flash-card agree-terms-conditions">
                {isUpdate ? (
                    <div className="card-header">
                        {language.terms_updated}
                    </div>
                ) : null}
                
                <div className="card-container">
                    {use_pdf && file_url ? (
                        <a
                            href={openLinkInNewTab ? "#" : file_url}
                            target="_blank"
                            onClick={(e: any) => {
                                openLinkInNewTab && e.preventDefault();
                                openLinkInNewTab && openLinkInNewTab(file_url);
                            }}
                        >
                            {language.terms_and_conditions_text}
                        </a>
                    ) : (
                        <div
                            className="view-only-text view-only-text-wrapper tiptap-view"
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(
                                    description ?? "",
                                ),
                            }}
                        />
                    )}
                    
                    <p className="agree-txt">{language.i_agree_text}</p>
                </div>
                <div className="card-footer">
                    <div className="btn-items">
                        <button
                            className="btn"
                            onClick={(e) => {
                                e.preventDefault();
                                setTermsAccepted(true);
                                if (submit.length === 1) {
                                    submit(e);
                                } else {
                                    submit();
                                }
                            }}
                        >
                            {language.yes_btn_text}
                        </button>
                        <button
                            className="btn btn-white"
                            onClick={(e) => {
                                e.preventDefault();
                                setTermsAccepted(false);
                            }}
                        >
                            {language.no_btn_text}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )

}